// extracted by mini-css-extract-plugin
export default {"section":"styles_section__heZ5L","title":"styles_title__ffn3Y","recentReportSectionWrapper":"styles_recentReportSectionWrapper__WFAlc","divider":"styles_divider__qPlh0"};